export default {
  ASSIGNED_TO_ME: "Assigned To Me",
  ASSIGNED_TO_SALES_EXECUTIVE: "Assigned To Sales Executive",
};
